var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 150",
    style: {
      enableBackground: "new 0 0 200 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.64,93.53h5.96c5.59,0,9.53,3.49,9.53,8.44c0,4.95-3.94,8.47-9.53,8.47h-5.96V93.53z M36.92,107.66 c3.57,0,6.08-2.36,6.08-5.69c0-3.32-2.51-5.66-6.08-5.66h-3.2v11.35H36.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.72,96.34v4.09h8.74v2.81h-8.74v4.41h9.65v2.81H50.64V93.53h12.73v2.81H53.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.03,93.53h8.3c2.93,0,5,1.77,5,4.23c0,1.72-0.89,2.93-2.39,3.74c1.94,0.94,3.1,2.49,3.1,4.33c0,2.71-2.24,4.6-5.39,4.6 h-8.62V93.53z M75.59,100.45c1.5,0,2.58-0.89,2.58-2.12c0-1.25-1.08-2.14-2.58-2.14h-4.51v4.26H75.59z M76.03,107.78 c1.67,0,2.85-1.01,2.85-2.41s-1.18-2.41-2.85-2.41h-4.95v4.82H76.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.43,103.23v-9.7h3.08v9.6c0,2.81,1.82,4.82,4.38,4.82c2.59,0,4.41-2.02,4.41-4.82v-9.6h3.05v9.7 c0,4.41-3.07,7.51-7.46,7.51C89.53,110.74,86.43,107.64,86.43,103.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.19,101.14h7.21v6.84c-1.63,1.7-4.26,2.76-6.72,2.76c-4.85,0-8.94-4.01-8.94-8.76c0-4.75,4.09-8.74,8.94-8.74 c2.46,0,5.1,1.03,6.72,2.73l-2.19,2.04c-1.06-1.23-2.88-1.97-4.53-1.97c-3.15,0-5.81,2.71-5.81,5.93c0,3.25,2.66,5.96,5.81,5.96 c1.28,0,2.66-0.44,3.72-1.21v-3.08h-4.21V101.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.96,101.14h7.21v6.84c-1.63,1.7-4.26,2.76-6.72,2.76c-4.85,0-8.94-4.01-8.94-8.76c0-4.75,4.09-8.74,8.94-8.74 c2.46,0,5.1,1.03,6.72,2.73l-2.19,2.04c-1.06-1.23-2.88-1.97-4.53-1.97c-3.15,0-5.81,2.71-5.81,5.93c0,3.25,2.66,5.96,5.81,5.96 c1.28,0,2.66-0.44,3.72-1.21v-3.08h-4.21V101.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.99,93.53h3.05v16.91h-3.05V93.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.29,93.53h3.08l8.94,11.89V93.53h3.05v16.91h-3.05l-8.94-11.89v11.89h-3.08V93.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.74,126.88v0.97h-4.79v-7.06H66v6.09H69.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.96,120.78H77v7.06h-1.04V120.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8,120.78h1.04l2.48,4.61l2.48-4.61h1.04v7.06h-1.04v-5.02l-2.48,4.61l-2.48-4.61v5.02H83.8V120.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63,120.78h1.04v7.06h-1.04V120.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.31,121.75H105v-0.97h5.67v0.97h-2.32v6.09h-1.04V121.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.02,121.75v2.01h3.74v0.97h-3.74v2.15h4.14v0.97h-5.19v-7.06h5.19v0.97H118.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.71,120.78h2.44c2.28,0,3.9,1.46,3.9,3.52s-1.62,3.53-3.9,3.53h-2.44V120.78z M131.21,126.9 c1.63,0,2.77-1.07,2.77-2.59c0-1.51-1.14-2.58-2.77-2.58h-1.46v5.17H131.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.87,45.74h-12.58c5.6,3.18,9.48,9.01,9.94,15.8c0,0,0,0,0,0c0.04,0.45,0.07,0.9,0.07,1.35c0,0.46-0.03,0.91-0.07,1.35 c0,0,0,0,0,0c-0.46,6.78-4.34,12.62-9.94,15.8h12.58l13.72-17.15L118.87,45.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.06,34.73L100,22.16L89.94,34.73l-2.52,3.15l6.29,7.86H81.13L67.41,62.89l13.72,17.15h12.58 c-5.6-3.18-9.48-9.01-9.94-15.8c0,0,0,0,0,0c-0.04-0.45-0.07-0.9-0.07-1.35c0-0.46,0.03-0.91,0.07-1.35c0,0,0,0,0,0 c0.46-6.78,4.34-12.62,9.94-15.8H100h6.29l6.29-7.86L110.06,34.73z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e8fc5d44b0a85003a28c2ce70854ece1.svg";
export { ForwardRef as ReactComponent };